import { jsx as B } from "react/jsx-runtime";
import { forwardRef as v, useRef as O, useState as Y, useEffect as Z } from "react";
import { u as M } from "./index-6a632112.mjs";
import { TextInput as k } from "./textInput.js";
import { i as W, f as V, e as J, a as K } from "./themes-5f0b3c3d.mjs";
import { l as L } from "./lineHeights-72d3110c.mjs";
import "./uniqueId-321287e8.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
const _ = [
  {
    currency: "Albania Lek",
    currencyCode: "ALL",
    currencySymbol: "&#76;&#101;&#107;"
  },
  {
    currency: "Afghanistan Afghani",
    currencyCode: "AFN",
    currencySymbol: "&#1547;"
  },
  {
    currency: "Argentina Peso",
    currencyCode: "ARS",
    currencySymbol: "&#36;"
  },
  {
    currency: "Aruba Guilder",
    currencyCode: "AWG",
    currencySymbol: "&#402;"
  },
  {
    currency: "Australia Dollar",
    currencyCode: "AUD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Azerbaijan New Manat",
    currencyCode: "AZN",
    currencySymbol: "&#1084;&#1072;&#1085;"
  },
  {
    currency: "Bahamas Dollar",
    currencyCode: "BSD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Barbados Dollar",
    currencyCode: "BBD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Belarus Ruble",
    currencyCode: "BYR",
    currencySymbol: "&#112;&#46;"
  },
  {
    currency: "Belize Dollar",
    currencyCode: "BZD",
    currencySymbol: "&#66;&#90;&#36;"
  },
  {
    currency: "Bermuda Dollar",
    currencyCode: "BMD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Bolivia Boliviano",
    currencyCode: "BOB",
    currencySymbol: "&#36;&#98;"
  },
  {
    currency: "Bosnia and Herzegovina Convertible Marka",
    currencyCode: "BAM",
    currencySymbol: "&#75;&#77;"
  },
  {
    currency: "Botswana Pula",
    currencyCode: "BWP",
    currencySymbol: "&#80;"
  },
  {
    currency: "Bulgaria Lev",
    currencyCode: "BGN",
    currencySymbol: "&#1083;&#1074;"
  },
  {
    currency: "Brazil Real",
    currencyCode: "BRL",
    currencySymbol: "&#82;&#36;"
  },
  {
    currency: "Brunei Darussalam Dollar",
    currencyCode: "BND",
    currencySymbol: "&#36;"
  },
  {
    currency: "Cambodia Riel",
    currencyCode: "KHR",
    currencySymbol: "&#6107;"
  },
  {
    currency: "Canada Dollar",
    currencyCode: "CAD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Cayman Islands Dollar",
    currencyCode: "KYD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Chile Peso",
    currencyCode: "CLP",
    currencySymbol: "&#36;"
  },
  {
    currency: "China Yuan Renminbi",
    currencyCode: "CNY",
    currencySymbol: "&#165;"
  },
  {
    currency: "Colombia Peso",
    currencyCode: "COP",
    currencySymbol: "&#36;"
  },
  {
    currency: "Costa Rica Colon",
    currencyCode: "CRC",
    currencySymbol: "&#8353;"
  },
  {
    currency: "Croatia Kuna",
    currencyCode: "HRK",
    currencySymbol: "&#107;&#110;"
  },
  {
    currency: "Cuba Peso",
    currencyCode: "CUP",
    currencySymbol: "&#8369;"
  },
  {
    currency: "Czech Republic Koruna",
    currencyCode: "CZK",
    currencySymbol: "&#75;&#269;"
  },
  {
    currency: "Denmark Krone",
    currencyCode: "DKK",
    currencySymbol: "&#107;&#114;"
  },
  {
    currency: "Dominican Republic Peso",
    currencyCode: "DOP",
    currencySymbol: "&#82;&#68;&#36;"
  },
  {
    currency: "East Caribbean Dollar",
    currencyCode: "XCD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Egypt Pound",
    currencyCode: "EGP",
    currencySymbol: "&#163;"
  },
  {
    currency: "El Salvador Colon",
    currencyCode: "SVC",
    currencySymbol: "&#36;"
  },
  {
    currency: "Estonia Kroon",
    currencyCode: "EEK",
    currencySymbol: "&#107;&#114;"
  },
  {
    currency: "Euro Member Countries",
    currencyCode: "EUR",
    currencySymbol: "&#8364;"
  },
  {
    currency: "Falkland Islands (Malvinas) Pound",
    currencyCode: "FKP",
    currencySymbol: "&#163;"
  },
  {
    currency: "Fiji Dollar",
    currencyCode: "FJD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Ghana Cedis",
    currencyCode: "GHC",
    currencySymbol: "&#162;"
  },
  {
    currency: "Gibraltar Pound",
    currencyCode: "GIP",
    currencySymbol: "&#163;"
  },
  {
    currency: "Guatemala Quetzal",
    currencyCode: "GTQ",
    currencySymbol: "&#81;"
  },
  {
    currency: "Guernsey Pound",
    currencyCode: "GGP",
    currencySymbol: "&#163;"
  },
  {
    currency: "Guyana Dollar",
    currencyCode: "GYD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Honduras Lempira",
    currencyCode: "HNL",
    currencySymbol: "&#76;"
  },
  {
    currency: "Hong Kong Dollar",
    currencyCode: "HKD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Hungary Forint",
    currencyCode: "HUF",
    currencySymbol: "&#70;&#116;"
  },
  {
    currency: "Iceland Krona",
    currencyCode: "ISK",
    currencySymbol: "&#107;&#114;"
  },
  {
    currency: "India Rupee",
    currencyCode: "INR",
    currencySymbol: "&#x20B9;"
  },
  {
    currency: "Indonesia Rupiah",
    currencyCode: "IDR",
    currencySymbol: "&#82;&#112;"
  },
  {
    currency: "Iran Rial",
    currencyCode: "IRR",
    currencySymbol: "&#65020;"
  },
  {
    currency: "Isle of Man Pound",
    currencyCode: "IMP",
    currencySymbol: "&#163;"
  },
  {
    currency: "Israel Shekel",
    currencyCode: "ILS",
    currencySymbol: "&#8362;"
  },
  {
    currency: "Jamaica Dollar",
    currencyCode: "JMD",
    currencySymbol: "&#74;&#36;"
  },
  {
    currency: "Japan Yen",
    currencyCode: "JPY",
    currencySymbol: "&#165;"
  },
  {
    currency: "Jersey Pound",
    currencyCode: "JEP",
    currencySymbol: "&#163;"
  },
  {
    currency: "Kazakhstan Tenge",
    currencyCode: "KZT",
    currencySymbol: "&#1083;&#1074;"
  },
  {
    currency: "Korea (North) Won",
    currencyCode: "KPW",
    currencySymbol: "&#8361;"
  },
  {
    currency: "Korea (South) Won",
    currencyCode: "KRW",
    currencySymbol: "&#8361;"
  },
  {
    currency: "Kyrgyzstan Som",
    currencyCode: "KGS",
    currencySymbol: "&#1083;&#1074;"
  },
  {
    currency: "Laos Kip",
    currencyCode: "LAK",
    currencySymbol: "&#8365;"
  },
  {
    currency: "Latvia Lat",
    currencyCode: "LVL",
    currencySymbol: "&#76;&#115;"
  },
  {
    currency: "Lebanon Pound",
    currencyCode: "LBP",
    currencySymbol: "&#163;"
  },
  {
    currency: "Liberia Dollar",
    currencyCode: "LRD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Lithuania Litas",
    currencyCode: "LTL",
    currencySymbol: "&#76;&#116;"
  },
  {
    currency: "Macedonia Denar",
    currencyCode: "MKD",
    currencySymbol: "&#1076;&#1077;&#1085;"
  },
  {
    currency: "Malaysia Ringgit",
    currencyCode: "MYR",
    currencySymbol: "&#82;&#77;"
  },
  {
    currency: "Mauritius Rupee",
    currencyCode: "MUR",
    currencySymbol: "&#8360;"
  },
  {
    currency: "Mexico Peso",
    currencyCode: "MXN",
    currencySymbol: "&#36;"
  },
  {
    currency: "Mongolia Tughrik",
    currencyCode: "MNT",
    currencySymbol: "&#8366;"
  },
  {
    currency: "Mozambique Metical",
    currencyCode: "MZN",
    currencySymbol: "&#77;&#84;"
  },
  {
    currency: "Namibia Dollar",
    currencyCode: "NAD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Nepal Rupee",
    currencyCode: "NPR",
    currencySymbol: "&#8360;"
  },
  {
    currency: "Netherlands Antilles Guilder",
    currencyCode: "ANG",
    currencySymbol: "&#402;"
  },
  {
    currency: "New Zealand Dollar",
    currencyCode: "NZD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Nicaragua Cordoba",
    currencyCode: "NIO",
    currencySymbol: "&#67;&#36;"
  },
  {
    currency: "Nigeria Naira",
    currencyCode: "NGN",
    currencySymbol: "&#8358;"
  },
  {
    currency: "Norway Krone",
    currencyCode: "NOK",
    currencySymbol: "&#107;&#114;"
  },
  {
    currency: "Oman Rial",
    currencyCode: "OMR",
    currencySymbol: "&#65020;"
  },
  {
    currency: "Pakistan Rupee",
    currencyCode: "PKR",
    currencySymbol: "&#8360;"
  },
  {
    currency: "Panama Balboa",
    currencyCode: "PAB",
    currencySymbol: "&#66;&#47;&#46;"
  },
  {
    currency: "Paraguay Guarani",
    currencyCode: "PYG",
    currencySymbol: "&#71;&#115;"
  },
  {
    currency: "Peru Nuevo Sol",
    currencyCode: "PEN",
    currencySymbol: "&#83;&#47;&#46;"
  },
  {
    currency: "Philippines Peso",
    currencyCode: "PHP",
    currencySymbol: "&#8369;"
  },
  {
    currency: "Poland Zloty",
    currencyCode: "PLN",
    currencySymbol: "&#122;&#322;"
  },
  {
    currency: "Qatar Riyal",
    currencyCode: "QAR",
    currencySymbol: "&#65020;"
  },
  {
    currency: "Romania New Leu",
    currencyCode: "RON",
    currencySymbol: "&#108;&#101;&#105;"
  },
  {
    currency: "Russia Ruble",
    currencyCode: "RUB",
    currencySymbol: "&#1088;&#1091;&#1073;"
  },
  {
    currency: "Saint Helena Pound",
    currencyCode: "SHP",
    currencySymbol: "&#163;"
  },
  {
    currency: "Saudi Arabia Riyal",
    currencyCode: "SAR",
    currencySymbol: "&#65020;"
  },
  {
    currency: "Serbia Dinar",
    currencyCode: "RSD",
    currencySymbol: "&#1044;&#1080;&#1085;&#46;"
  },
  {
    currency: "Seychelles Rupee",
    currencyCode: "SCR",
    currencySymbol: "&#8360;"
  },
  {
    currency: "Singapore Dollar",
    currencyCode: "SGD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Solomon Islands Dollar",
    currencyCode: "SBD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Somalia Shilling",
    currencyCode: "SOS",
    currencySymbol: "&#83;"
  },
  {
    currency: "South Africa Rand",
    currencyCode: "ZAR",
    currencySymbol: "&#82;"
  },
  {
    currency: "Sri Lanka Rupee",
    currencyCode: "LKR",
    currencySymbol: "&#8360;"
  },
  {
    currency: "Sweden Krona",
    currencyCode: "SEK",
    currencySymbol: "&#107;&#114;"
  },
  {
    currency: "Switzerland Franc",
    currencyCode: "CHF",
    currencySymbol: "&#67;&#72;&#70;"
  },
  {
    currency: "Suriname Dollar",
    currencyCode: "SRD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Syria Pound",
    currencyCode: "SYP",
    currencySymbol: "&#163;"
  },
  {
    currency: "Taiwan New Dollar",
    currencyCode: "TWD",
    currencySymbol: "&#78;&#84;&#36;"
  },
  {
    currency: "Thailand Baht",
    currencyCode: "THB",
    currencySymbol: "&#3647;"
  },
  {
    currency: "Trinidad and Tobago Dollar",
    currencyCode: "TTD",
    currencySymbol: "&#84;&#84;&#36;"
  },
  {
    currency: "Turkey Lira",
    currencyCode: "TRY",
    currencySymbol: "&#x20BA;"
  },
  {
    currency: "Turkey Lira",
    currencyCode: "TRL",
    currencySymbol: "&#8356;"
  },
  {
    currency: "Tuvalu Dollar",
    currencyCode: "TVD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Ukraine Hryvna",
    currencyCode: "UAH",
    currencySymbol: "&#8372;"
  },
  {
    currency: "United Kingdom Pound",
    currencyCode: "GBP",
    currencySymbol: "&#163;"
  },
  {
    currency: "United States Dollar",
    currencyCode: "USD",
    currencySymbol: "&#36;"
  },
  {
    currency: "Uruguay Peso",
    currencyCode: "UYU",
    currencySymbol: "&#36;&#85;"
  },
  {
    currency: "Uzbekistan Som",
    currencyCode: "UZS",
    currencySymbol: "&#1083;&#1074;"
  },
  {
    currency: "Venezuela Bolivar",
    currencyCode: "VEF",
    currencySymbol: "&#66;&#115;"
  },
  {
    currency: "Viet Nam Dong",
    currencyCode: "VND",
    currencySymbol: "&#8363;"
  },
  {
    currency: "Yemen Rial",
    currencyCode: "YER",
    currencySymbol: "&#65020;"
  },
  {
    currency: "Zimbabwe Dollar",
    currencyCode: "ZWD",
    currencySymbol: "&#90;&#36;"
  }
], j = ({
  value: r,
  groupSeparator: y = ",",
  decimalSeparator: n = ".",
  allowDecimals: i = !0,
  decimalsLimit: o = 2,
  allowNegativeValue: C = !0
}) => {
  if (r === "-")
    return r;
  const D = /((^|\D)-\d)|(-)/.test(r), p = X(r, y), t = q(p, [
    y,
    n
  ]), m = t, d = D && C ? "-" : "";
  if (n && m.includes(n)) {
    const [R, s] = t.split(n), h = o && s ? s.slice(0, o) : s, P = i ? `${n}${h}` : "";
    return `${d}${R}${P}`;
  }
  return `${d}${m}`;
}, Q = function(r, y) {
  return y.split(r)[1]?.length || 0;
}, T = (r) => r?.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), X = (r, y = ",") => {
  const n = new RegExp(T(y), "g");
  return r?.replace(n, "");
}, q = (r, y) => {
  const n = T(y.join("")), i = new RegExp(`[^\\d${n}]`, "gi");
  return r?.replace(i, "");
}, rr = M.div`
  input {
    text-align: right;
  }
  #startAdornment_id {
    margin: unset;
    color: ${(r) => r.$isDisabled ? "unset" : r.$isTyped ? W.default : "unset"};
    font-family: ${V.inter};
    font-weight: ${J.regular.S.fontWeight};
    ${(r) => r.$size === "small" ? `
          font-size:${K.xsmall};
          line-height: ${L.small};
        ` : r.$size === "large" ? `
          font-size:${K.medium};
          line-height: ${L.large};]
        ` : `
          font-size:${K.small};
          line-height: ${L.medium};
        `}
  }
`, cr = M.div`
  display: flex;
  align-items: center;
`, Lr = v(
  ({
    currencyCode: r = "USD",
    showErrorIcon: y = !0,
    isRequired: n = !1,
    size: i = "medium",
    value: o = "",
    isInvalid: C = !1,
    isDisabled: g = !1,
    helperText: D,
    placeholder: p = "00.00",
    onChange: t,
    onBlur: m,
    locale: d = "en-us",
    labelProp: R,
    infoProp: s,
    trailingText: h,
    ...P
  }, I) => {
    const f = O(null), [N, S] = Y(null);
    Z(() => {
      const c = f.current;
      c && c?.setSelectionRange(N, N);
    }, [f, N, o]);
    const G = ({ value: c, diff: u, total: l }) => {
      c.length === 0 ? S(1) : u === 0 ? S(l) : u < 0 ? S(l + Math.abs(u) - 1) : S(l - Math.abs(u) + 1);
    }, $ = (c, u, l = !1) => {
      let a = j({
        value: u
      });
      a = a?.replace(",", ".");
      const F = Q(".", a), A = parseFloat(a);
      let e = "";
      if (a.charAt(a.length - 1) !== ".") {
        let b = 2;
        l || (b = Math.min(F, 2));
        const U = new Intl.NumberFormat(d, {
          style: "currency",
          currency: r,
          minimumFractionDigits: b,
          maximumFractionDigits: b
        }).format(A);
        isNaN(A) || (e = U);
      } else
        e = `${new Intl.NumberFormat(d, {
          style: "currency",
          currency: r,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(A)}.`;
      e = e.includes("-") && e.charAt(0) === "-" ? "-" + e.slice(2) : e.slice(1), e.includes(" ") && (e = e.split(" ")[1]), a === "-" && (e = "-" + e);
      const H = c.target.selectionEnd, x = o?.length - e.length;
      G({ value: o, diff: x, total: H }), c.target.value = e, t && t(c);
    }, E = (c) => {
      $(c, c.target.value);
    }, w = (c) => {
      $(c, c.target.value, !0), m && m(c);
    }, z = (c) => {
      const u = _.find(
        ({ currencyCode: l }) => l === c
      );
      return /* @__PURE__ */ B(
        cr,
        {
          id: "startAdornment_id",
          dangerouslySetInnerHTML: {
            __html: u ? u.currencySymbol : ""
          }
        }
      );
    };
    return /* @__PURE__ */ B(
      rr,
      {
        $isDisabled: g,
        $size: i,
        $isTyped: o?.length > 0,
        children: /* @__PURE__ */ B(
          k,
          {
            inputRef: f,
            value: o,
            placeholder: p,
            textSize: i,
            isRequired: n,
            isInvalid: C,
            helperText: D,
            disabled: g,
            showErrorIcon: y,
            startAdornment: z(r),
            onChange: E,
            onBlur: w,
            maxLength: 15,
            labelProp: { showRequiredIndicator: n, ...R },
            infoProp: { ...s },
            trailingText: h,
            ref: I,
            ...P
          }
        )
      }
    );
  }
);
export {
  Lr as CurrencyInput
};
